import React, {createRef, useContext, useRef} from "react";
import {Button, Card, Col, Container, Form, FormControl, FormGroup, Row} from "react-bootstrap";
import useCallBackend from "../../hooks/use-call-backend";
import {LoginRequest} from "../../modal/login-request";
import {useState} from "react";
import {LoginResponse} from "../../modal/login-response";
import Error from "../../common/error";
import Loading from "../../common/loading";
import AuthContext from "../../store/auth-context";
import {Link, useNavigate} from "react-router-dom";
import {Email} from "../../modal/email";
import ReCAPTCHA from "react-google-recaptcha";
// @ts-ignore
import classes from './index.module.css';
// @ts-ignore
import lightstoneLogo from "../../assets/images/Lightstone-Logo.jpg";
import "../../css/login.css"
import ContactInfo from "../../common/contact-info";

const Login:React.FC = () => {
    const {isLoading, error, invokeBackend} = useCallBackend();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [email, setEmail] = useState<string>("");
    const [pass, setPass] = useState<string>("");
    const authCtx = useContext(AuthContext);
    let navigate = useNavigate();
    const recaptchaRef = createRef<ReCAPTCHA>();
    const recapchaSiteKey = process.env.REACT_APP_RECAPCHA_SITEKEY === undefined ? "" : process.env.REACT_APP_RECAPCHA_SITEKEY;

    const handleLoginResult = (loginResponse: LoginResponse) => {
        if(!loginResponse.successful) {
            setErrorMessage(loginResponse.message);
        }else if(loginResponse.passwordExpired){
            const mailState:Email = {email: email};
            navigate("/passwordExpired", {state: mailState});
        }else if(loginResponse.token === null || loginResponse.expiresIn === null || loginResponse.passwordExpired === null) {
            setErrorMessage("Did not successfully login.")
        }else{
            const expiresInMilliseconds = new Date().getTime() + (loginResponse.expiresIn * 1000);
            const expirationTime = new Date(expiresInMilliseconds);
            authCtx.login(loginResponse.token, expirationTime.toISOString(), loginResponse.institutions);
        }
    }

    const handleFormSubmit = async (event:React.FormEvent) => {
        setErrorMessage(null); //reset
        event.preventDefault();

        const token = await recaptchaRef.current?.executeAsync();

        if(token === undefined || token === null || token === ""){
            setErrorMessage("reCapcha failed!");
            return;
        }

        if(email === "" || pass === ""){
            setErrorMessage("Email and Password are required!");
            return;
        }

        const loginRequest: LoginRequest = {
            email: email,
            password: pass,
            capcha: token
        }

        invokeBackend({url:"/api/auth/userLogin",
                dontAddAuth: true,
                method: "POST",
                body: JSON.stringify(loginRequest)},
                handleLoginResult);
    }

    let displayError = null;

    if(error || errorMessage){
        displayError = (
            <Row>
                <Col>
                    {error && <Error message={error} />}
                    {errorMessage && <Error message={errorMessage} />}
                </Col>
            </Row>
        );
    }

    const loginForm = (
        <React.Fragment>
            {displayError}
            <Row>
                <Col>
                    <Form onSubmit={handleFormSubmit}>
                        <FormGroup>
                            <FormControl type="email" placeholder="Email address" autoComplete="off" required value={email}
                                         onChange={(e) => {setEmail(e.target.value)}} />
                        </FormGroup>
                        <FormGroup className="mt-3">
                            <FormControl type="password" autoComplete="off" placeholder="Password" required value={pass}
                                         onChange={(e) => {setPass(e.target.value)}} />
                        </FormGroup>
                        <FormGroup>
                            <p style={{textAlign: "right"}}>
                                <Link to="forgotPassword">Forgot Password?</Link>
                            </p>
                            <Button variant="primary" className="mt-3" type="submit">Login</Button>
                        </FormGroup>
                        <ReCAPTCHA sitekey={recapchaSiteKey} size="invisible" ref={recaptchaRef} />
                    </Form>
                </Col>
            </Row>
        </React.Fragment>
    );

    const loadingContent = (
        <Row>
            <Col>
                <Loading overrideStyle="h2" />
            </Col>
        </Row>
    );

    return <Container fluid className="login">
        <Row className="g-0 vh-100">
            <Col lg={6} className="d-flex justify-content-center align-items-center">
                <Row className="loginWidth">
                    <Col>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Header>Signio VAP Supplier Portal: Login</Card.Header>
                                    <Card.Body>
                                        {isLoading && loadingContent}
                                        {!isLoading && loginForm}
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-center">
                                <ContactInfo />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <img src={lightstoneLogo} alt="Lightstone Logo" />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col lg={6} />
        </Row>
    </Container>;
}

export default Login;